/**
 * DocumentSetProgressBadge
 */
import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { Label } from 'semantic-ui-react';

// Selectors
import { makeSelectDocumentSetValue } from 'services/documentSets/selectors';

interface Props {
    jobState: string;
}

export class DocumentSetProgressBadge extends React.PureComponent<Props> {
    render() {
        const { jobState } = this.props;
        if (jobState === 'DONE') {
            return (
                <Label size="small" color="pink">
                    DONE
                </Label>
            );
        }
        if (jobState === 'IN_PROGRESS') {
            return (
                <Label size="small" color="green">
                    IN PROGRESS
                </Label>
            );
        }
        if (jobState === 'READY') {
            return <Label size="small">READY TO START</Label>;
        }
        return null;
    }
}

const mapStateToProps = createStructuredSelector({
    jobState: makeSelectDocumentSetValue('jobState')
});

export default connect(mapStateToProps)(DocumentSetProgressBadge);
